module.exports = __webpack_public_path__ + "static/CircularStd-BoldItalic-0e6d9b8b90f594ac632236d11bbda6ee.ttf";